import { Options } from 'highcharts';
import styles from './style.module.scss';

const baseFontStyles = {
    fontFamily: styles['font-family'],
    color: styles.color,
    fontSize: '12px',
};
const axisFontStyles = {
    ...baseFontStyles,
    fontSize: '11px',
};

const DefaultHighchartOptions: Options = {
    exporting: { enabled: false, chartOptions: { chart: { style: baseFontStyles } } },
    credits: {
        enabled: false,
    },
    title: {
        text: '',
        style: {
            fontWeight: '600',
        },
    },
    palette: {
        colorScheme: 'light',
    },
    chart: {
        style: baseFontStyles,
        zooming: {
            resetButton: {
                theme: {
                    r: 2,
                    fill: styles['--bg-colour-button'],
                    stroke: 'none',
                    height: 10,
                    style: {
                        color: 'white',
                        fontSize: '12px',
                    },
                    states: {
                        hover: {
                            fill: styles['--bg-colour-button-hover'],
                            stroke: 'none',
                            style: {
                                color: 'white',
                            },
                        },
                    },
                },
            },
        },
    },
    xAxis: {
        labels: {
            style: axisFontStyles,
        },
        title: {
            style: axisFontStyles,
        },
    },
    yAxis: {
        labels: {
            style: axisFontStyles,
        },
        title: {
            style: axisFontStyles,
        },
    },
    tooltip: {
        shadow: false,
        borderWidth: 1,
        style: baseFontStyles,
        borderColor: undefined,
    },
    subtitle: {
        style: baseFontStyles,
    },
    legend: {
        itemStyle: baseFontStyles,
        navigation: {
            activeColor: styles.color,
        },
    },
};

export default DefaultHighchartOptions;
